import { FloatingDelayGroup } from '@floating-ui/react'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import store from '@services/store'

import { AlertProvider } from '@contexts/AlertProvider'
import { ConnectedIntlProvider, LanguageLoadErrorAlert } from '@contexts/ConnectedIntlProvider'
import { SuccessDialogProvider } from '@contexts/SuccessDialogProvider'

import { InitializeApplication } from '@components/InitializeApplication'
import { AppIntercomProvider } from '@components/Intercom'
import { NewVersionBar } from '@components/NewVersionBar'
import { PageTitle } from '@components/PageTitle'

import { FLOATING_TRANSITION_DURATION, STYLED_THEME } from '@constants'

import router from './router'

import { GlobalStyle } from '@styles/GlobalStyle'

function App() {
  return (
    <Provider store={store}>
      <AppIntercomProvider>
        <StyledThemeProvider theme={STYLED_THEME}>
          <GlobalStyle />
          <ConnectedIntlProvider>
            <SuccessDialogProvider>
              <AlertProvider>
                <PageTitle />
                <LanguageLoadErrorAlert />
                <NewVersionBar />
                <InitializeApplication>
                  <FloatingDelayGroup delay={FLOATING_TRANSITION_DURATION}>
                    <RouterProvider router={router} />
                  </FloatingDelayGroup>
                </InitializeApplication>
              </AlertProvider>
            </SuccessDialogProvider>
          </ConnectedIntlProvider>
        </StyledThemeProvider>
      </AppIntercomProvider>
    </Provider>
  )
}

export default App
